/* eslint-disable max-len */
import React from 'react';

export const whatsApp = (color = 'rgba(125,125,125, 0.5)', filled = true, width = 16, height = 16) => (
  <svg width={width} height={height} viewBox='-233 356 128 128' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M-169 356.9c-35.3 0-64 28.7-64 64 0 14 4.5 27 12.2 37.5l-8 23.8 24.6-7.9c10.1 6.7 22.2 10.6 35.2 10.6 35.3 0 64-28.7 64-64s-28.7-64-64-64zm37.3 90.4c-1.5 4.4-7.7 8-12.6 9-3.3.7-7.7 1.3-22.4-4.8-18.8-7.8-30.9-26.9-31.9-28.1-.9-1.2-7.6-10.1-7.6-19.3 0-9.2 4.7-13.7 6.5-15.6 1.5-1.6 4.1-2.3 6.5-2.3.8 0 1.5 0 2.1.1 1.9.1 2.8.2 4.1 3.2 1.5 3.7 5.3 12.9 5.8 13.8.5.9.9 2.2.3 3.5-.6 1.3-1.1 1.8-2.1 2.9-.9 1.1-1.8 1.9-2.8 3.1-.9 1-1.8 2.1-.8 4 1.1 1.8 4.9 8 10.4 12.9 7.1 6.4 12.9 8.4 15 9.3 1.5.6 3.4.5 4.5-.7 1.4-1.5 3.2-4.1 5-6.6 1.3-1.8 2.9-2 4.6-1.4 1.7.6 10.9 5.1 12.8 6.1 1.9.9 3.1 1.4 3.6 2.2.5.6.5 4.3-1 8.7z'
      fillRule='evenodd'
      clipRule='evenodd'
      fill={filled ? color : 'none'}
    />
  </svg>
);
